import { ReactNode } from 'react';
import { MarketButton } from '@market/react';

// if more MarketButton props are needed, we can add them here
// i.e. if we want to add href, target, variant, etc.
interface SecondaryProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

const Secondary = ({ children, className = '', onClick }: SecondaryProps) => {
  return (
    <MarketButton
      rank="secondary"
      className={className}
      onClick={onClick}
      data-testid="cta-subnav-secondary"
    >
      {children}
    </MarketButton>
  );
};

export default Secondary;
